<template>
  <div
    :class="
      'dot-count text-center vs-avatar--count badgeNumber progress-multi dot-count-' +
      CssSuffix
    "
    :style="getTotalsClass()"
  >
    <span v-if="ShowNumbers" :title="ToolTip" class="progress-text">{{ CurrentItemsCount }}</span>
  </div>
</template>
<script>
export default {
  methods: {
    getTotalsClass() {
      return `
      position: initial;
      float: left;
      max-height: 5px;
      color: black;
      padding-top: 3px;
      font-size: 10px;
      font-weight: bold;
      margin-top: 15px;
      width:${this.calculateWidth()} !important`;
    },
    calculateWidth(){
      var calculatedSize = (this.CurrentItemsCount / this.TotalItems) * 100;
      var result = calculatedSize <= 0 ? "calc(5% * .75)" : "calc(" + calculatedSize + "% * .75)";
      return result;
    }
  },
  props: [
    "TotalItems",
    "CurrentItemsCount",
    "CurrentItemsState",
    "CurrentItemName",
    "CssSuffix",
    "Width",
    "ToolTip",
    "ShowNumbers"
  ],
};
</script>
<style scoped>
.dot-count-unset {
  background: #828282;
}
.dot-count-coach {
  background: #027dcf;
}
</style>
